<template>
    <Head title="Log in" />

    <jet-authentication-card>
        <div class="flex flex-col text-center w-full mb-4">
            <LogoAppSquare class="h-24 w-24 m-auto" />
        </div>

        <jet-validation-errors class="mb-4" />

        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>

<!--        <form @submit.prevent="submit">-->
<!--            <div>-->
<!--                <jet-label for="username" value="Username" />-->
<!--                <jet-input-->
<!--                    id="username"-->
<!--                    type="text"-->
<!--                    class="mt-1 block w-full"-->
<!--                    v-model="form.username"-->
<!--                    required-->
<!--                    autofocus-->
<!--                />-->
<!--            </div>-->

<!--            <div class="mt-4">-->
<!--                <jet-label for="password" value="Pasword" />-->
<!--                <jet-input-->
<!--                    id="password"-->
<!--                    type="password"-->
<!--                    class="mt-1 block w-full"-->
<!--                    v-model="form.password"-->
<!--                    required-->
<!--                    autocomplete="current-password"-->
<!--                />-->
<!--            </div>-->

<!--            <div class="flex items-center justify-between mt-4">-->
<!--                <label class="flex items-center">-->
<!--                    <jet-checkbox-->
<!--                        name="remember"-->
<!--                        v-model:checked="form.remember"-->
<!--                    />-->
<!--                    <span class="ml-2 text-sm text-gray-600">Remember me</span>-->
<!--                </label>-->
<!--                <Link-->
<!--                    v-if="canResetPassword"-->
<!--                    :href="route('password.request')"-->
<!--                    class="underline text-sm text-gray-600 hover:text-gray-900"-->
<!--                >-->
<!--                    I forgot my password-->
<!--                </Link>-->
<!--            </div>-->
<!--            <div class="mt-4" >-->
<!--                &lt;!&ndash;             &ndash;&gt;-->
<!--                <div class="sample-captcha">-->
<!--                    <section class="data-box">-->
<!--                        <jet-input-->
<!--                            v-model="inputValue"-->
<!--                            placeholder="submit your captcha"-->
<!--                            class="input"-->
<!--                            type="text"-->
<!--                        />-->

<!--                        &lt;!&ndash;                        <pre class="data">{{ data }}</pre>&ndash;&gt;-->
<!--                    </section>-->

<!--                    <section class="captcha-box">-->
<!--                        <VueClientRecaptcha-->
<!--                            :value="inputValue"-->
<!--                            @getCode="getCaptchaCode"-->
<!--                            @isValid="checkValidCaptcha"-->
<!--                        />-->
<!--                    </section>-->
<!--                </div>-->

<!--            </div>-->
<!--            <div class="py-4">-->
<!--                <div class="border-t border-gray-200"></div>-->
<!--            </div>-->

<!--            <div class="flex items-center justify-end">-->
<!--                <InertiaButtonLogin-->
<!--                    class="mr-1"-->
<!--                    :class="{ 'opacity-25': form.processing }"-->
<!--                    label="Login"-->
<!--                />-->
<!--                <ButtonReset></ButtonReset>-->
<!--            </div>-->
<!--            <div-->
<!--                v-if="canRegister"-->
<!--                class="-->
<!--                    bg-amber-100-->
<!--                    border border-red-700-->
<!--                    text-red-700-->
<!--                    mt-4-->
<!--                    px-4-->
<!--                    py-4-->
<!--                    rounded-->
<!--                    relative-->
<!--                    text-center-->
<!--                "-->
<!--                role="alert"-->
<!--            >-->
<!--                <strong class="font-bold"-->
<!--                    ><i class="fa-solid fa-circle-exclamation mr-2"></i-->
<!--                ></strong>-->
<!--                <span class="block sm:inline"-->
<!--                    >Belum punya akun, silahkan mendaftar-->
<!--                    <Link-->
<!--                        v-if="canResetPassword"-->
<!--                        :href="route('register')"-->
<!--                        class="underline text-red-700 hover:text-red-500"-->
<!--                    >-->
<!--                        disini-->
<!--                    </Link></span-->
<!--                >-->
<!--            </div>-->
<!--            <div class="text-center mt-4">-->
<!--                <Link-->
<!--                    :href="route('index')"-->
<!--                    class="-->
<!--                        underline-->
<!--                        text-sm text-blue-700-->
<!--                        hover:text-[#4338CA]-->
<!--                        font-semibold-->
<!--                    "-->
<!--                >-->
<!--                    Homepage-->
<!--                </Link>-->
<!--            </div>-->
<!--        </form>-->
        <div class="flex justify-center mt-6">
            <a
                :href="route('azure.login')"
                class="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 px-6 rounded-lg shadow transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
            >
                <!-- Ikon Microsoft -->
                <svg class="w-5 h-5" viewBox="0 0 24 24">
                    <rect width="10" height="10" x="1" y="1" fill="#F35325"/>
                    <rect width="10" height="10" x="13" y="1" fill="#81BC06"/>
                    <rect width="10" height="10" x="1" y="13" fill="#05A6F0"/>
                    <rect width="10" height="10" x="13" y="13" fill="#FFBA08"/>
                </svg>
                Login dengan SSO Microsoft
            </a>
        </div>

    </jet-authentication-card>
</template>

<script>
import { defineComponent } from "vue";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard";
import LogoUndip from "@/Logo/LogoUndip";
import LogoAppSquare from "@/Logo/LogoAppSquare";
import InertiaButtonLogin from "@/Components/InertiaButtonLogin.vue";
import ButtonReset from "@/Components/ButtonReset.vue";
import JetInput from "@/Jetstream/Input";
import JetCheckbox from "@/Jetstream/Checkbox";
import JetLabel from "@/Jetstream/Label";
import JetValidationErrors from "@/Jetstream/ValidationErrors";
import JetSectionBorder from "@/Jetstream/SectionBorder";
import { Head, Link } from "@inertiajs/inertia-vue3";
import { ref, reactive } from "@vue/reactivity";
import VueClientRecaptcha from "vue-client-recaptcha";

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        LogoUndip,
        LogoAppSquare,
        InertiaButtonLogin,
        ButtonReset,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        JetSectionBorder,
        Link,
        VueClientRecaptcha,
    },

    props: {
        canResetPassword: Boolean,
        canRegister: Boolean,
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                username: "",
                password: "",
                remember: false,
            }),

        };
    },

    methods: {
        submit() {
            // cek captcha
            if (this.data.isValid) {
                this.form
                    .transform((data) => ({
                        ...data,
                        remember: this.form.remember ? "on" : "",
                    }))
                    .post(this.route("login"), {
                        onFinish: () => this.form.reset("password"),
                    });
            } else {
                alert("Captcha Salah");
            }
        },
    },
    setup() {
        /* pass value to captcha  */
        const inputValue = ref(null);

        const data = reactive({
            captchaCode: null,
            isValid: false,
        });
        const getCaptchaCode = (value) => {
            /* you can access captcha code */
            data.captchaCode = value;
        };
        const checkValidCaptcha = (value) => {
            /* expected return boolean if your value and captcha code are same return True otherwise return False */
            data.isValid = value;
            if (value) {

            }
        };
        return {
            inputValue,
            data,
            getCaptchaCode,
            checkValidCaptcha,
        };
    },
});
</script>
